import { Card } from 'Card';
import { ImportantCtaBoxHeader } from './ImportantCtaBoxHeader';
import { ImportantCtaBoxIcon } from './ImportantCtaBoxIcon';
import { ImportantCtaBoxDescription } from './ImportantCtaBoxDescription';
import { ImportantCtaBoxCta } from './ImportantCtaBoxCta';

type Props = {
    headerSubtitle: string;
    headerTitle: string;
    icon: React.ReactNode;
    iconCircle?: boolean;
    color?: 'primary' | 'purple';
    ctaText: string;
    onPressCta: () => void;
    children: React.ReactNode; // This is the description text
    testId?: string;
};

export function ImportantCtaBox({
    color = 'primary',
    headerSubtitle,
    headerTitle,
    icon,
    iconCircle,
    ctaText,
    onPressCta,
    children,
    testId,
}: Props) {
    // NOTE: Currently we have an issue filed with HeroUI where the radius variant is not being applied correctly,
    // so we're waiting on that to be fixed or a solution to be offered, but ok to merge beforehand because we aren't
    // releasing this yet. So radius={2} is the correct radius, but it's not yet being applied.
    // https://github.com/heroui-inc/heroui/issues/5293
    return (
        <Card width="full" shadow={false} padding="top-6" radius={2} startBorderColor={color}>
            <div data-testid={`important-cta-box-${testId}`}>
                <ImportantCtaBoxHeader subtitle={headerSubtitle} title={headerTitle} />
                <ImportantCtaBoxIcon icon={icon} circle={iconCircle} color={color} />
                <ImportantCtaBoxDescription>{children}</ImportantCtaBoxDescription>
                <ImportantCtaBoxCta color={color} onPressCta={onPressCta} ctaText={ctaText} />
            </div>
        </Card>
    );
}
